// extracted by mini-css-extract-plugin
export default {"card":"KjFSMAhF6NOPop3eGLAg"};